import React, { Component, useRef } from "react";
import client from "@culturehq/client";
import { ActionButton, Loader } from "@culturehq/components";
import LastIntersectedElement from "components/admin/settings/LastIntersectedElement";

import { Trans } from "app/utils";

import ErrorBoundary from "components/common/ErrorBoundary";

import Comment from "components/comments/Comment";
import SocialComment from "./SocialComment";

const SocialCommentItems = ({
  lazyLoadingContainerRef,
  comments,
  linkedinShare,
  loading,
  onReacted,
  onPostSocialComment,
  onToggleShowMore
}) => {
  const elements = comments.map(comment => (
    <SocialComment
      key={comment.id}
      comment={comment}
      onPostSocialComment={onPostSocialComment}
      onReacted={onReacted}
      linkedinShare={linkedinShare}
    />
  ));
  if (loading) elements.push(<Loader loading />);
  if (onToggleShowMore) {
    elements.push(
      <LastIntersectedElement
        rootRef={lazyLoadingContainerRef}
        onNearScreen={onToggleShowMore}
      />
    );
  }

  return elements;
};

const StandardCommentItems = ({
  showMore,
  comments,
  hideLinks,
  onCheerToggle,
  onToggleShowMore,
  handleSubmit,
  handleDelete
}) => {
  const elements = (showMore ? comments : comments.slice(0, 3)).map(comment => (
    <Comment
      key={comment.id}
      comment={comment}
      hideLinks={hideLinks}
      onSubmit={handleSubmit}
      onDelete={handleDelete}
      onCheerToggle={onCheerToggle}
    />
  ));


  if (!showMore && comments.length > 3) {
    elements.push(
      <div className="text-center">
        <ActionButton
          className="comments--show-more"
          icon="ios-chatbubble-outline"
          onClick={onToggleShowMore}
        >
          <Trans>Show More Comments</Trans>
        </ActionButton>
      </div>
    );
  }

  return elements;
};


class CommentsList extends Component {
  static defaultProps = {
    onChange: () => {}
  }

  componentWillUnmount() {
    this.componentIsMounted = false;
  }

  handleSubmit = async values => {
    const { options, createCall, onCreateComment } = this.props;

    const { comment } = await createCall({ ...options, ...values });
    onCreateComment(comment);
  };

  handleDelete = async deletedComment => {
    const { onDeleteComment } = this.props;
    try {
      await client.deleteComment({ commentId: deletedComment.id });

      onDeleteComment(deletedComment);
    } catch (error) {
      if (error.status !== 404) {
        throw error;
      }
    }
  };

  render() {
    const {
      lazyLoadingContainerRef, comments, onCheerToggle, onToggleShowMore, showMore, hideLinks,
      onPostSocialComment, onReacted, linkedinShare, loading
    } = this.props;

    return onPostSocialComment ? (
      <SocialCommentItems
        lazyLoadingContainerRef={lazyLoadingContainerRef}
        comments={comments}
        linkedinShare={linkedinShare}
        loading={loading}
        onReacted={onReacted}
        onPostSocialComment={onPostSocialComment}
        onToggleShowMore={onToggleShowMore}
      />
    ) : (
      <StandardCommentItems
        showMore={showMore}
        comments={comments}
        hideLinks={hideLinks}
        onCheerToggle={onCheerToggle}
        onToggleShowMore={onToggleShowMore}
        handleSubmit={this.handleSubmit}
        handleDelete={this.handleDelete}
      />
    );
  }
}

export default props => (
  <div className="comments row clearfix">
    <div className="col-sm-12">
      <ErrorBoundary>
        <CommentsList {...props} />
      </ErrorBoundary>
    </div>
  </div>
);
